export const isExternalLink = (href: string): boolean => {
  return new RegExp(/^(https?:\/\/|mailto:|tel:)/).test(href)
}
